export default "__VITE_PUBLIC_ASSET__30e11b24__"